import { FormikProps } from 'formik';
import React from 'react';
import { LabelAndValue } from '../../../../global/components/data-display/label-value';
import { FormField } from '../../../../global/components/form-element/form-field';
import { FormGroup } from '../../../../global/components/layout/form-group';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { SearchPerson } from './person-search-model';

interface Props {    
    businessEmailLabel: string;    
    formProps: FormikProps<any>;
    selectedPerson: SearchPerson;
}

export function BusinessEmailRequiredDisplay(props: Props) {
    const { 
        formProps,
        businessEmailLabel,        
        selectedPerson } = props;

    const renderBusinessEmail = () => {
        if (!selectedPerson) {
            return (
                <LabelAndValue label={businessEmailLabel} value={formProps.values.office_email_address} />
            );
        }

        return (
            <FormGroup>

                <FormField
                    name='office_email_address'
                    component='input'
                    label={businessEmailLabel}
                    touched={formProps.touched}
                    errors={formProps.errors}
                    required
                />
            </FormGroup>
        );
    };

    return (
        <ContentSpacer>            
            {renderBusinessEmail()}
        </ContentSpacer>
    );
}